export default __webpack_public_path__ + "static/media/howler_audio_test.69bba893.mp3";